import { render, staticRenderFns } from "./ModalCreateItem.vue?vue&type=template&id=402a32a0&scoped=true"
import script from "./ModalCreateItem.vue?vue&type=script&lang=ts"
export * from "./ModalCreateItem.vue?vue&type=script&lang=ts"
import style0 from "./ModalCreateItem.vue?vue&type=style&index=0&id=402a32a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402a32a0",
  null
  
)

export default component.exports